module.exports = __webpack_public_path__ + "img/Yipi_AnimacionWeb_08.0497f27c.gif";